import {
    feedSetKnowledgeFilter,
    feedClearFilterCriteria,
    feedApplyFilterCriteria
} from "../../../actions/feed-actions"

import buildFilterWidgetContainer from "../../common/build-filter-widget-container"

import FeedKnowledgeListFilterFormContainer from "./FeedKnowledgeListFilterFormContainer"

export default buildFilterWidgetContainer(
    FeedKnowledgeListFilterFormContainer,
    feedClearFilterCriteria,
    feedApplyFilterCriteria,
    feedSetKnowledgeFilter
)
